import { render, staticRenderFns } from "./ValutationPromoter.vue?vue&type=template&id=0f00327b&"
import script from "./ValutationPromoter.vue?vue&type=script&lang=js&"
export * from "./ValutationPromoter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports